import { render, staticRenderFns } from "./Comentarios.vue?vue&type=template&id=cd026768&"
import script from "./Comentarios.vue?vue&type=script&lang=js&"
export * from "./Comentarios.vue?vue&type=script&lang=js&"
import style0 from "./Comentarios.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports